import State from "../../Player/states/states.js";

import { EnemyStateConfig } from "../../GameConfig/EnemyConfig.js";

export default class Fly extends State {
  constructor(enemy, img_src, maxFrame) {
    super(EnemyStateConfig.FLY);
    this.enemy = enemy;
    this.imgSrc = img_src;
    this.maxFrame = maxFrame;
  }

  enter() {
    this.enemy.image.src = this.imgSrc;
    this.enemy.maxFrame = this.maxFrame;
    this.enemy.frameX = 0;
  }

  update(deltaTime) {
    this.enemy.x += this.enemy.speed;
    if (this.enemy.x < -this.enemy.spriteWidth) {
      this.enemy.markedForDeletion = true;
    }

    if (this.enemy.canAttack) {
      this.enemy.attackTimer += deltaTime;
      if (this.enemy.attackTimer > this.enemy.attackInterval) {
        this.enemy.setState(EnemyStateConfig.ATTACK);
        this.enemy.attackTimer = 0;
      }
    }
  }
}
